"use strict";
var Observable_1 = require('../../Observable');
var takeUntil_1 = require('../../operator/takeUntil');
Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
//# sourceMappingURL=takeUntil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/takeUntil.js
// module id = 492
// module chunks = 0